import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

import {
  allAssignmentsStateConfig,
  childAssignmentsStateConfig,
  childAssignmentStateConfig,
  currentAssignmentsStateConfig,
  META_ACTION_TYPE_ROOT
} from "../consts";

export const {
  fetchAllActionFactory: fetchCurrentStudentAssignmentsActionFactory
} = makeCrudStateActionFactories(currentAssignmentsStateConfig);

export const {
  fetchAllActionFactory: fetchAllStudentAssignmentsActionFactory,
  fetchActionFactory: fetchStudentAssignmentActionFactory
} = makeCrudStateActionFactories(allAssignmentsStateConfig);

export const { fetchActionFactory: fetchChildAssignmentsActionFactory } =
  makeCrudStateActionFactories(childAssignmentsStateConfig);

export const { fetchActionFactory: fetchChildAssignmentActionFactory } =
  makeCrudStateActionFactories(childAssignmentStateConfig);

export const resetFetchStudentAssignmentAction = (assignmentId: string) => {
  return {
    type: `${META_ACTION_TYPE_ROOT}/FETCH_PAST-STUDENT-ASSIGNMENTS_RESET`,
    payload: {
      assignmentId
    }
  };
};
